"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _styledComponent = require("./components/styledComponent.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["children", "spacing", "className", "gap"];
const Grid = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
      children,
      spacing,
      className = '',
      gap
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const customClassName = rest.container ? spacing ? `mun-grid-spacing-${spacing}` : '' : `mun-grid-item`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponent.StyledGrid, Object.assign({}, rest, {
    spacing: spacing,
    gap: gap,
    themeSpacing: theme.spacing.spacing,
    className: `mun-grid ${customClassName} ${className}`,
    children: children
  }));
};
var _default = exports.default = Grid;
module.exports = exports.default;
module.exports.default = exports.default;